import { useState } from "react";
import { Link, useSearchParams, useNavigate } from "react-router-dom";
import { AuthShell } from "@/components/AuthShell";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import client, { apiError } from "@/lib/api";

export default function Reset() {
    const [params] = useSearchParams();
    const token = params.get("token") || "";
    const navigate = useNavigate();
    const [password, setPassword] = useState("");
    const [error, setError] = useState("");
    const [done, setDone] = useState(false);
    const [loading, setLoading] = useState(false);

    const submit = async (e) => {
        e.preventDefault();
        setError("");
        if (password.length < 8 || !/[A-Za-z]/.test(password) || !/\d/.test(password)) {
            setError("La contraseña necesita 8 caracteres con letras y números.");
            return;
        }
        setLoading(true);
        try {
            await client.post("/auth/reset-password", { token, password });
            setDone(true);
            setTimeout(() => navigate("/acceder"), 2000);
        } catch (err) {
            setError(apiError(err));
        } finally {
            setLoading(false);
        }
    };

    return (
        <AuthShell
            title="Elige una nueva contraseña"
            subtitle="Que sea fácil de recordar para ti y difícil de adivinar para el resto."
            footer={
                <Link to="/acceder" className="font-medium text-terracotta hover:underline">
                    Volver a entrar
                </Link>
            }
        >
            {!token ? (
                <div className="rounded-lg border border-line bg-card p-5 text-[15px] text-subtle">
                    Este enlace no es válido. Pide uno nuevo desde{" "}
                    <Link to="/recuperar" className="text-terracotta hover:underline">recuperar contraseña</Link>.
                </div>
            ) : done ? (
                <div data-testid="reset-success" className="rounded-lg border border-line bg-card p-5 text-[16px] text-ink">
                    Tu contraseña se ha actualizado. Te llevamos al acceso…
                </div>
            ) : (
                <form onSubmit={submit} className="space-y-5" noValidate>
                    {error && (
                        <div data-testid="reset-error" className="rounded-lg border border-destructive/30 bg-destructive/5 px-4 py-3 text-[14px] text-destructive">
                            {error}
                        </div>
                    )}
                    <div className="space-y-2">
                        <Label htmlFor="password">Nueva contraseña</Label>
                        <Input id="password" type="password" value={password} onChange={(e) => setPassword(e.target.value)}
                            data-testid="reset-password" placeholder="Mínimo 8 caracteres" required />
                    </div>
                    <Button type="submit" disabled={loading} data-testid="reset-submit" className="w-full h-11 text-[15px]">
                        {loading ? "Guardando…" : "Guardar contraseña"}
                    </Button>
                </form>
            )}
        </AuthShell>
    );
}
